// 引入api
import { fun_GetAction, fun_PostAction } from "@/api";
import { deepCopy } from "@/utils/validate.js";
// 引入加密方法
import "@/utils/security.js";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 抽屉状态
      drawerStatus: false,
      // 抽屉确定按钮loading状态
      loading: false,
      // 查询表单字段
      form: {
        id: null, // id
        yhlb: null, // 用户类别
        yhmc: null, // 用户名称
        yhmm: null, // 用户密码
        zsxm: null, // 真实名称
        yhxb: null, // 用户性别
        bmbh: null, // 所属单位
        lxdh: null, // 联系电话
        lxcz: null, // 联系传真
        lxdz: null, // 联系地址
        dzyx: null, // 电子邮箱
        yhzt: null, // 用户状态
        jsid: null, // 角色
        qgdm: null, // 监管部门
        qgbz: null, // 部门锁标志
        lszjczbz: null, // 临时专家操作标志
        secretKey: null, // 谷歌身份验证key值
        googleVerify: null // 是否开启谷歌验证标志
      },
      // 表单提交返回的错误消息
      errRules: {
        id: null, // id
        yhlb: null, // 用户类别
        yhmc: null, // 用户名称
        yhmm: null, // 用户密码
        zsxm: null, // 真实名称
        yhxb: null, // 用户性别
        bmbh: null, // 所属单位
        lxdh: null, // 联系电话
        lxcz: null, // 联系传真
        lxdz: null, // 联系地址
        dzyx: null, // 电子邮箱
        yhzt: null, // 用户状态
        jsid: null, // 角色
        qgdm: null, // 监管部门
        qgbz: null, // 部门锁标志
        lszjczbz: null, // 临时专家操作标志
        secretKey: null, // 谷歌身份验证key值
        googleVerify: null // 是否开启谷歌验证标志
      },
      // 详情表单基础数据
      formConfigList: [
        {
          label: "身份证号:",
          value: "id",
          type: "input",
          required: true,
          rule: [
            {
              required: true,
              message: "请输入身份证号",
              trigger: "blur"
            },
            {
              pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
              message: "请输入正确的身份证号"
            }
          ]
        },
        {
          label: "用户类别:",
          value: "yhlb",
          type: "radio",
          required: true,
          rule: {
            required: true,
            message: "请选择用户类别",
            trigger: "blur"
          },
          option: [
            {
              label: "平台工作人员",
              value: "01"
            },
            {
              label: "招标监管人员",
              value: "02"
            }
          ]
        },
        {
          label: "用户名称:",
          value: "yhmc",
          type: "input",
          required: true,
          maxlength: 60,
          rule: {
            required: true,
            message: "请输入用户名称",
            trigger: "blur"
          }
        },
        {
          label: "用户密码:",
          value: "yhmm",
          type: "password",
          maxlength: 60,
          required: true,
          rule: {
            required: true,
            message: "请输入用户密码",
            trigger: "blur"
          }
        },
        {
          label: "真实姓名:",
          value: "zsxm",
          type: "input",
          maxlength: 100,
          required: true,
          rule: {
            required: true,
            message: "请输入真实姓名",
            trigger: "blur"
          }
        },
        {
          label: "用户性别:",
          value: "yhxb",
          type: "radio",
          required: true,
          rule: {
            required: false,
            message: "请选择用户性别",
            trigger: "blur"
          },
          option: [
            {
              label: "男",
              value: "00"
            },
            {
              label: "女",
              value: "01"
            }
          ]
        },
        {
          label: "所属单位:",
          type: "select",
          value: "bmbh",
          placeholder: "请输入",
          queryParams: {
            url: "/dataDictionaryEntries/DictionaryCombobox",
            zdid: "201509171417560003"
          },
          rule: {
            required: true,
            message: "请选择所属单位",
            trigger: "blur"
          }
        },
        {
          label: "联系电话:",
          value: "lxdh",
          type: "input",
          maxlength: 20,
          required: true,
          rule: {
            required: false,
            message: "请输入联系电话",
            trigger: "blur"
          }
        },
        {
          label: "联系传真:",
          value: "lxcz",
          type: "input",
          required: true,
          maxlength: 20,
          rule: {
            required: false,
            message: "请输入联系传真",
            trigger: "blur"
          }
        },
        {
          label: "联系地址:",
          value: "lxdz",
          type: "input",
          required: true,
          maxlength: 200,
          rule: {
            required: false,
            message: "请输入联系地址",
            trigger: "blur"
          }
        },
        {
          label: "电子邮箱:",
          value: "dzyx",
          type: "input",
          required: true,
          maxlength: 100,
          rule: [
            {
              required: false,
              message: "请输入电子邮箱",
              trigger: "blur"
            },
            {
              pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
              message: "请输入格式正确的邮箱"
            }
          ]
        },
        {
          label: "角色编号:",
          value: "jsid",
          type: "slot",
          slotName: "jsid",
          required: true,
          rule: {
            required: true,
            message: "请选择角色",
            trigger: "change"
          }
        },
        {
          label: "监管部门:",
          type: "select",
          value: "qgdm",
          placeholder: "请输入",
          queryParams: {
            url: "/regulatorsCombobox",
            processType: "201510311952460006"
          },
          rule: {
            required: true,
            message: "请选择监管部门",
            trigger: "blur"
          }
        },
        {
          label: "部门锁标志:",
          value: "qgbz",
          type: "radio",
          required: true,
          rule: {
            required: false,
            message: "请选择部门锁标志",
            trigger: "blur"
          },
          option: [
            {
              label: "否",
              value: "00"
            },
            {
              label: "是",
              value: "01"
            }
          ]
        },
        {
          label: "临时专家操作标志:",
          value: "lszjczbz",
          type: "radio",
          required: true,
          rule: {
            required: true,
            message: "请选择临时专家操作标志",
            trigger: "blur"
          },
          option: [
            {
              label: "允许操作",
              value: "01"
            },
            {
              label: "不允许操作",
              value: "02"
            }
          ]
        },
        {
          label: "用户状态:",
          value: "yhzt",
          type: "radio",
          required: true,
          rule: {
            required: false,
            message: "请输入用户状态",
            trigger: "blur"
          },
          option: [
            {
              label: "启用",
              value: "0"
            },
            {
              label: "废止",
              value: "1"
            }
          ]
        },
        {
          label: "是否开启谷歌验证:",
          value: "googleVerify",
          type: "radio",
          required: true,
          rule: {
            required: false,
            message: "请选择是否开启谷歌验证",
            trigger: "blur"
          },
          option: [
            {
              label: "开启",
              value: "1"
            },
            {
              label: "关闭",
              value: "0"
            }
          ]
        },
      ],
      // 加密key
      key: null,
      // 菜单下拉框
      optionData: [],
      // 操作标志
      controllerFlag: null,
      // 因rsa解密无效，这里保存原有的密码
      oldPassword: null,
    };
  },
  // 模板编译完成
  mounted() {
    // 获取一览表格数据
    this.fun_SelectCombobox();
  },
  // 自定义方法
  methods: {
    /**
     * 获取详情
     * @author 滕威
     */
    async fun_GetDetails(id) {
      this.form.id = id;
      // 请求，获取结果集
      let res = await fun_PostAction("/v2User/detail?id=" + id);
      // 解构res.data
      const { result, data, msg } = res.data;
      // 判断请求是否成功
      if (result) {
        // 回显表单
        // 赋值
        for (let key in this.form) {
          // 存在值
          if (data[key]) {
            // 赋值
            this.form[key] = data[key];
          }
          // 如果是密码
          if (key === "yhmm") {
            // 拷贝值
            this.oldPassword = deepCopy(data[key])
          }
        }
      } else {
        // 请求失败，提示错误信息
        this.$message.error(msg);
      }
    },
    /**
     * 表单提交
     * @author 滕威
     */
    fun_SubmitForm() {
      // 校验
      this.$refs.form.$refs.enInform.validate(valid => {
        // 校验通过
        if (valid) {
          // 打开确定按钮loading状态
          this.loading = true;
          this.form.yhmm = window.RSAUtils.encryptedString(
            this.key,
            this.form.yhmm
          );
          // 发起请求，获取结果集
          fun_PostAction("/v2User/saveOrUpdate", {
            controllerFlag: this.controllerFlag, // 操作标志
            ...this.form
          })
            .then(res => {
              // 解构res.data
              const { result, msg, data } = res.data;
              // 判断请求是否成功
              if (result) {
                // 请求一览查询接口
                this.$parent.fun_GetList();
                // 关闭弹窗
                this.drawerStatus = false;
                // 提示信息
                this.$message.success(msg);
              } else {
                // 如果存在返回数据
                if (data != null) {
                  // 定义rules为一个随机数
                  this.errRules = Math.random();
                  // 执行延迟方法
                  this.$nextTick(() => {
                    // 提示
                    this.$message.error("请按提示修改");
                    // 赋值错误消息
                    this.errRules = data;
                  });
                } else {
                  // 请求失败，提示信息
                  this.$message.error(msg);
                }
                this.form.yhmm = deepCopy(this.oldPassword);
              }
              // 取消确定按钮loading状态
              this.loading = false;
            })
            .catch(() => {
              // 取消确定按钮loading状态
              this.loading = false;
            });
          // 获取一览表格数据
          this.fun_SelectCombobox();
        } else {
          // 校验不通过，返回false，页面给出提示
          return false;
        }
      });
    },
    /**
     * 抽屉打开时执行
     * @author 滕威
     */
    fun_DrawerOpen() {
      this.fun_GetRSAKey();
    },
    /**
     * 抽屉关闭时执行
     * @author 滕威
     */
    fun_DrawerClose() {
      // 清空所属机构和角色下拉框
      // 遍历formItem
      this.$refs.form.$refs.formItem.map(e => {
        // 找到所属机构和角色下拉框
        if (e.prop === "jsid") {
          // 置空
          e.$children[1].value = null;
        }
      });
      // this.fun_Clear();
      // 清除表单验证和数据
      this.$refs.form.$refs.enInform.resetFields();
      // 关闭时，清除勾选
      this.$parent.$refs.list.$refs.multipleTable.clearSelection();
    },
    /**
     * 选择下拉框事件
     * @param {e} 选择的value值
     * @param {val} 下拉框的字段
     * @author 滕威
     */
    fun_GetSelectVal(e, val) {
      // 遍历查询表单对象
      for (const key in this.form) {
        // 判断key和val是否相同
        if (key == val) {
          // 相同则复制给表单
          this.form[key] = e;
        }
      }
    },
    /**
     * 获取加密key接口
     * @author 滕威
     */
    fun_GetRSAKey() {
      // 调用获取加密参数接口
      fun_PostAction("/getRSAKey").then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 获取加密key
          this.key = window.RSAUtils.getKeyPair(
            data.exponent,
            "",
            data.modulus
          );
        }
      });
    },
    /**
     * 获取菜单下拉框
     */
    async fun_SelectCombobox() {
      // 请求，获取结果集
      let res = await fun_PostAction("/v2SysPower/list");
      // 解构res.data
      const { data } = res.data;
      // 重新赋值
      this.optionData = [];
      // 回显表单
      for (let i in data) {
        data[i].value = data[i].id;
        this.optionData.push(data[i]);
      }
    },
    /**
     * 选择上级菜单下拉框事件
     * @param {e} 选中的value
     * @author 滕威
     */
    fun_SelectChange(e) {
      // 回显
      this.form.jsid = e.code;
    }
  }
};
